import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppContainer from "./layout/AppContainer";
import { store } from "./app/store";
import { ConfigProvider } from "antd";
import { colors, fontFamily, radius } from "./theme/tokens";

const antdTheme = {
  token: {
    colorPrimary: colors.primary,
    colorLink: colors.primary,
    colorBgLayout: colors.bgLayout,
    colorBorder: colors.border,
    colorBorderSecondary: colors.border,
    borderRadius: radius.base,
    fontFamily: fontFamily,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.danger,
  },
  components: {
    Menu: {
      darkItemBg: colors.sidebarBg,
      darkItemColor: colors.sidebarText,
      darkItemSelectedBg: colors.sidebarBgActive,
      darkItemSelectedColor: colors.sidebarTextActive,
      darkItemHoverBg: 'rgba(255,255,255,0.08)',
      darkItemHoverColor: colors.sidebarTextActive,
    },
    Layout: {
      siderBg: colors.sidebarBg,
      headerBg: colors.bgCard,
    },
    Card: {
      borderRadiusLG: radius.lg,
    },
    Button: {
      borderRadius: radius.sm,
    },
  },
};

const App: React.FC = () => {
  return (
    <ConfigProvider theme={antdTheme}>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<AppContainer />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </ConfigProvider>
  )
}

export default App